<template>
  <div class="nav-list">
    <div class="nav-list-item cur">
      <div class="nav-list-title">
        <i class="iconfont icon-tongxunlu01"></i>通讯录
      </div>
      <div class="contacts">
        <div class="contacts-tree">
          <!-- 通讯录树形结构 -->
          <el-tree :data="contactData" :props="defaultProps" node-key="depId" @node-click="handleNodeClick" 
            :default-expanded-keys="[1]"></el-tree>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        contactData: [],
        defaultProps: {
          children: 'childDepts',
          label: 'name'
        }
      }
    },
    mounted() {
      this.getContactsList()

    },
    methods: {
      getContactsList() {
        ajax.get('/dept/list', '', (res) => {
          this.contactData = res.vo.array
          this.$store.commit('set_organization', res.vo.array)
        })
      },
      // 点击目录
      handleNodeClick(data) {
        this.$store.commit("set_contactCurNode", data)
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/ContactsNav.vue